import { WidgetComponent } from './casino_section_components';

const WidgetComponentContainer = (props) => (
  <WidgetComponent {...props} className="right-sidebar-components__widget" title />
);

export default WidgetComponentContainer;
